import React from "react";
import { Table } from "antd";
import styled from "styled-components";

const StyledTable = styled(Table)`

 ${({ maxHeight }) => `
    .ant-table {
      border-radius: 5px;
      font-size: 14px;
      white-space: nowrap;
      max-height: ${maxHeight || "calc(90vh - 180px)"};
      overflow: auto;
      @media (min-width: 1440px) { /* Larger screens */
         max-height: calc(90vh - 200px);
      }
    }
  `}
  .ant-table-thead > tr > th {
    position: sticky;
    top: 0;
    z-index: 4; 
    padding: 10px;
    background-color: rgb(245, 243, 243);
    font-weight: 500;
  }
  .ant-table-tbody > tr > td {
    padding: 5px 16px;
    font-size: 13px;
    min-width: 100px;
   
  }
  .ant-table-pagination {
    display: flex;
    /* flex-end keeps the page numbers + size dropdown grouped together on the
       right (not stretched across the full width like space-between did). The
       total text, when present, uses margin-right:auto to jump to the left. */
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    padding: 0 16px;
    gap: 4px;
  }

  /* Total text pinned left; everything after it (pages + size dropdown) is
     pushed to the right as one neat group. */
  .ant-pagination-total-text {
    margin-right: auto;
  }

  .ant-pagination-options {
    margin-left: 8px;
  }
  .normal {
    min-width: 300px;
    white-space: normal;
    word-break: break-word;
  }
`;

const CustomTable = ({
  columns,
  data,
  loading,
  rowKey,
  pagination,
  onRowClick,
  rowSelection,
  onTableChange,
  maxHeight,
  scroll
}) => {
  return (
    <div>
      <StyledTable
        columns={columns}
        dataSource={data}
        loading={loading}
        rowKey={rowKey || "id"}
        pagination={pagination}
        onChange={onTableChange}
        onRow={(record) => ({
          onClick: () => onRowClick && onRowClick(record),
        })}
        rowSelection={rowSelection}
        bordered
        locale={{ emptyText: loading ? "Loading" : "No Data" }}
        maxHeight={maxHeight}
        scroll={scroll}
        
      />
    </div>
  );
};

export default CustomTable;
